<template>
    <main class="a">
        <section class="hero">
            <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                <div class="info-container tw-flex tw-flex-col tw-items-start lg:tw-items-start tw-justify-center lg:tw-justify-start">
                    <div class="logo">
                        <img src="~@/assets/img/logo-white.svg"/>
                    </div>
                    <div class="main-text">
                        <h3>
                            <span>Adira ao</span><br>
                            <b>Seguro Automóvel</b><br>
                            <span>Que se adapta às suas necessidades</span>
                        </h3>
                    </div>
                    <div class="selo">
                        <img src="~@/assets/img/selo.svg">
                    </div>
                </div>
                <div class="form-container">
                    <div class="form-icon">
                        <img src="~@/assets/img/icons/form-icon.svg"/>
                    </div>
                    <h1 v-if="!$store.state.formError && !$store.state.formSuccess">PEÇA A SUA SIMULAÇÃO</h1>
                    <Form v-if="!$store.state.formSuccess && !$store.state.formError" />
                    <FormSuccess v-if="$store.state.formSuccess && !$store.state.formError" />
                    <FormError v-if="$store.state.formError && !$store.state.formSuccess" />
                </div>
            </div>
        </section>
        <section class="bullets-grid">
            <div class="tw-block">
                <div>
                    <h1>FIDELIDADE AUTO</h1>
                    <h2>PARA VEÍCULOS COM TODAS AS IDADES</h2>
                    <p>Não existem dois condutores iguais e por isso temos um seguro para cada um. Desde o seguro auto obrigatório, com serviços mínimos, até à modalidade de máxima segurança e conforto, para quem valoriza a sua proteção, da sua família e contra danos provocados no seu automóvel.</p>
                    <h3>Vantagens Diferenciadoras</h3>
                    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3 lg:tw-gap-12 tw-mx-auto lg:tw-mx-0">
                        <div>
                            <div class="icon">
                                <img src="~@/assets/img/icons/grid-check.svg"/>
                            </div>
                            <div>
                                <h4>À medida das suas necessidades</h4>
                                <p>O seguro Fidelidade Auto disponibiliza um conjunto de 5 planos, com diferentes graus de proteção. Quer pretenda uma proteção para fazer face ao exigido por lei com os serviços mínimos, quer pretenda uma proteção mais abrangente que inclua os danos causados ao automóvel e passageiros, temos a solução para si.</p>
                            </div>
                        </div>
                        <div>
                            <div class="icon">
                                <img src="~@/assets/img/icons/grid-check.svg"/>
                            </div>
                            <div>
                                <h4>Cobertura de Assistência em Viagem</h4>
                                <p>Garantimos a assistência em viagem através de um conjunto alargado de serviços. Desde pequenos incidentes como avarias, falta de bateria e/ou combustível, furo de pneus, a situações mais graves e delicadas como a organização de serviço fúnebre, sendo esta uma garantia única no mercado.</p>
                            </div>
                        </div>
                        <div>
                            <div class="icon">
                                <img src="~@/assets/img/icons/grid-check.svg"/>
                            </div>
                            <div class="icon">
                                <h4>Qualidade e Garantia</h4>
                                <p>Em caso de acidente, tem à sua disposição uma rede de oficinas selecionadas pela Fidelidade, onde poderá contar com uma viatura de cortesia durante o período de reparação e ainda uma garantia de 2 anos em qualquer reparação.</p>
                            </div>
                        </div>
                        <div>
                            <div class="icon">
                                <img src="~@/assets/img/icons/grid-check.svg"/>
                            </div>
                            <div>
                                <h4>Proteção adequada a veículos<br> elétricos e híbridos</h4>
                                <p>O seguro Fidelidade Auto assegura a proteção necessária para veículos elétricos e híbridos, bem como para os respetivos cabos de carregamento, na estrada e durante o processo de carga. Além disso, garante o transporte do veículo se ficar sem bateria.</p>
                            </div>
                        </div>
                        <div>
                            <div class="icon">
                                <img src="~@/assets/img/icons/grid-check.svg"/>
                            </div>
                            <div>
                                <h4>Proteção Vital do condutor</h4>
                                <p>Em caso de acidente do qual decorram danos ao condutor, garantimos o pagamento de despesas médicas, tratamentos e assistência, que possibilitem a recuperação da qualidade de vida do condutor e o apoio à estabilidade financeira da sua família, até ao valor de 500.000€.</p>
                            </div>
                        </div>
                        <div>
                            <div class="icon">
                                <img src="~@/assets/img/icons/grid-check.svg"/>
                            </div>
                            <div>
                                <h4>Todos os seus veículos na mesma apólice</h4>
                                <p>Pode incluir todos os seus veículos na mesma apólice, até 10 veículos, tornando a gestão do seu seguro muito mais simples.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="banner">
                    <img src="~@/assets/img/banner-auto.jpg" class="tw-hidden lg:tw-block" />
                    <img src="~@/assets/img/banner-auto-mobile.jpg" class="tw-block lg:tw-hidden" />
                </div>
            </div>
        </section>
        <section class="request">
            <div class="tw-container">
                <h2>SAIBA QUAL A SOLUÇÃO DE SEGURO <br>MAIS ADEQUADA PARA SI</h2>
                <button class="btn-cta tw-mx-auto tw-block" v-scroll-to="'.hero'">Pedir Simulação</button>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
import FormError from '@/components/FormError.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
        FormError,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';

main {

    section {

        &.hero {

            @screen lg {
                height: 850px;
            }

            .info-container {
                @apply tw-relative tw-bg-no-repeat tw-bg-cover tw-bg-top;
                padding: 0px 16px 0px 16px;
                background-image: url('~@/assets/img/hero-bg_a-mobile.jpg');
                background-position-y: -5px;
                height: 257px;

                @screen lg {
                    background-position-y: unset !important;
                    @apply tw-bg-bottom;
                    background-image: url('~@/assets/img/hero-bg_a.jpg');
                    padding: 30px 55px 72px 55px;
                    height: 850px;
                }

                @screen xl {
                    padding: 50px 70px 72px 100px;
                }

                .logo {
                    @apply tw-block tw-mx-auto tw-relative;
                    top: -50px;

                    @screen lg {
                        @apply tw-mx-0 tw-top-0;
                    }

                    >img {
                        @apply tw-pointer-events-none;
                        width: 150px;

                        @screen lg {
                            width: 281.3px;
                        }
                    }
                }

                .main-text {
                    @apply tw-block tw-relative tw-pl-2;
                    border-left: solid 6px $main_color;
                    top: -35px;

                    @screen lg {
                        @apply tw-pl-4;
                        border-left: solid 12px $main_color;
                        top: 100px;
                    }

                    h3 {
                        @apply tw-text-left tw-text-white tw-uppercase tw-block tw-ml-auto tw-mx-auto tw-relative;
                        font-family: $font_title;
                        font-size: 32px;
                        line-height: 20px;
                        width: fit-content;

                        @screen lg {
                            @apply tw-mr-0;
                            font-size: 54px;
                            line-height: 40px;
                        }

                        @screen xl {
                            font-size: 70px;
                            line-height: 50px;
                        }

                        b {

                            @screen lg {
                                @apply tw-relative;
                                top: -0.5px;
                            }

                            @screen xl {
                                @apply tw-relative;
                                top: 3.5px;
                            }
                        }

                        span {
                            font-size: 18px;
                            line-height: 24px;

                            @screen lg {
                                font-size: 29px;
                                line-height: 40px;
                            }

                            @screen lg {
                                font-size: 39px;
                                line-height: 50px;
                            }
                        }

                        sup {
                            @apply tw-relative;
                            font-size: 40%;
                            top: -12px;

                            @screen lg {
                                font-size: 32.5%;
                                top: -30px;
                            }
                        }
                    }
                }

                .selo {
                    @apply tw-absolute;
                    bottom: 20px;

                    @screen lg {
                        bottom: 107.7px;
                    }

                    img {
                        width: 50px;

                        @screen lg {
                            width: 120px;
                        }
                    }
                }
            }

            .form-container {
                @apply tw-relative;
                background-color: $main_color;
                padding: 40px 16px 17px 16px;

                @screen lg {
                    padding: 65px 55px 72px 55px;
                    height: 850px;
                }

                @screen xl {
                    padding: 65px 100px 72px 100px;
                }

                .form-icon {
                    @apply tw-absolute tw-top-0;
                    left: 50%;
                    transform: translateX(-50%);

                    >img {
                        @apply tw-pointer-events-none;
                        width: 78px;
                        height: 39px;

                        @screen lg {
                            width: 119px;
                            height: 60px;
                        }
                    }
                }

                h1 {
                    @apply tw-font-bold tw-uppercase tw-text-white tw-text-center tw-mx-auto;
                    font-family: $font_title;
                    font-size: 26px;
                    width: 100%;

                    @screen lg {
                        font-size: 48px;
                        padding-top: 10px;
                        padding-bottom: 20px;
                        min-width: 400px;
                    }
                }
            }
        }

        &.bullets-grid {
            padding: 42.5px 0;

            @screen lg {
                padding: 90px 0;
            }

            >.tw-block {
                @apply tw-mx-auto tw-relative tw-px-5;

                @screen lg {
                    @apply tw-px-0;
                }

                div {

                    h1 {
                        @apply tw-font-bold tw-text-center tw-uppercase;
                        font-family: $font_title;
                        color: $main_color;
                        font-size: 34px;

                        @screen lg {
                            font-size: 60px;
                            line-height: 72px;
                        }
                    }

                    h2 {
                        @apply tw-font-bold tw-text-xl tw-text-center tw-uppercase;
                        font-family: $font_title;
                        color: $text;
                        margin-bottom: 10px;

                        @screen lg {
                            font-size: 36px;
                            line-height: 42px;
                            margin-bottom: 22px;
                        }
                    }

                    p {
                        @apply tw-text-center tw-block tw-mx-auto;
                        font-size: 16px;
                        line-height: 24px;
                        margin-bottom: 36px;
                        color: $text;

                        @screen lg {
                            font-size: 18px;
                            line-height: 28px;
                            max-width: 1144px;
                            margin-bottom: 76px;
                        }
                    }

                    h3 {
                        @apply tw-font-bold tw-uppercase tw-text-center tw-block tw-mx-auto;
                        color: $text;
                        font-family: $font_title !important;
                        font-size: 27px;
                        margin-bottom: 18px;

                        @screen lg {
                            @apply tw-text-left tw-mx-0;
                            padding-left: 80px;
                            font-size: 36px;
                            margin-bottom: 37px;
                        }

                        @screen xl {
                            padding-left: 120px;
                        }
                    }

                    .tw-grid {
                        @apply tw-mx-auto tw-relative tw-bg-white tw-z-10;
                        width: fit-content;

                        @screen lg {
                            width: auto;
                            margin-left: 80px;
                            max-width: 650px;
                        }

                        @screen xl {
                            margin-left: 120px;
                            max-width: 824px;
                        }

                        >div {
                            @apply tw-flex tw-gap-3 tw-items-start;

                            .icon {
                                min-width: 37px !important;

                                @screen lg {
                                    min-width: none !important;
                                }
                            }

                            @screen lg {
                                height: 200px;
                            }

                            img {
                                @apply tw-pointer-events-none tw-relative;
                                width: 44px;
                                height: 44px;

                                @screen lg {
                                    width: 60px;
                                    height: 60px;
                                }
                            }

                            h4 {
                                @apply tw-font-bold tw-uppercase;
                                font-family: $font_title;
                                color: $text;
                                font-size: 22px;
                                line-height: 24px;
                                margin-bottom: 3px;

                                @screen lg {
                                    font-size: 24px;
                                    line-height: 26px;
                                }
                            }

                            p {
                                @apply tw-font-normal tw-text-left;
                                font-family: $font_title;
                                font-size: 14px;
                                line-height: 20px;
                                color: $text;

                                @screen lg {
                                    max-width: 300px;
                                }
                            }
                        }
                    }
                }

                .banner {
                    @apply tw-relative tw-overflow-hidden;
                    width: 100%;
                    right: -20px;

                    @screen lg {
                        @apply tw-absolute tw-float-right;
                        top: 400px;
                        width: 40%;
                    }

                    @screen xl {
                        top: 364px;
                        width: 32%;
                    }

                    >img {
                        @apply tw-pointer-events-none tw-w-full;
                    }
                }
            }
        }

        &.request {
            background-color: $grey;
            padding: 47.5px 0;

            @screen lg {
                padding: 81.5px 0;
            }

            .tw-container {

                h2 {
                    @apply tw-text-center tw-font-bold tw-mx-auto;
                    font-family: $font_title;
                    color: $text;
                    font-size: 26px;
                    line-height: 32px;
                    margin-bottom: 20px;

                    span {
                        color: $main_color;
                    }

                    @screen lg {
                        font-size: 44px;
                        line-height: 53px;
                        margin-bottom: 30px;
                    }
                }

                >button {
                    width: 260px !important;

                    @screen lg {
                        width: 300px !important;
                    }
                }
            }
        }
    }
}

</style>
